import { useSyncExternalStore } from "react";

function subscribe(cb: () => void): () => void {
  const vv = window.visualViewport;
  if (!vv) return () => {};
  vv.addEventListener("resize", cb);
  return () => { vv.removeEventListener("resize", cb); };
}

function getSnapshot(): boolean {
  const vv = window.visualViewport;
  return vv ? vv.height < window.innerHeight * 0.75 : false;
}

/**
 * Heuristic for "the on-screen keyboard is probably open": the
 * visualViewport (which shrinks when the keyboard is up on mobile browsers)
 * is significantly smaller than the layout viewport. Always false in jsdom
 * (no visualViewport) and in browsers that don't support the API.
 */
export function useKeyboardOpen(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, () => false);
}
